import { useRef } from "react";
import type { ReactNode } from "react";
import classnames from "classnames";
import { useClickAway } from "react-use";
import { useDetectEscapeKeyPress } from "../../../hooks/useDetectEscapeKeyPress";
import { ModalBody } from "./ModalBody";
import { ModalHeader } from "./ModalHeader";

// eslint-disable-next-line no-barrel-files/no-barrel-files -- Conversion from js to ts
export * from "./ModalBody";
// eslint-disable-next-line no-barrel-files/no-barrel-files -- Conversion from js to ts
export * from "./ModalHeader";

interface ModalDeprecatedProps {
  children: ReactNode;
  className?: string;
  closeOnEscape?: boolean;
  closeOnOutsideClick?: boolean;
  fullscreen?: boolean;
  innerClassName?: string;
  onClose?: () => void;
  show: boolean;
  trixMode?: string;
}

/** @deprecated Please use the new modal at "@circle-react-uikit/ModalV2" */
export const Modal_DEPRECATED = ({
  children,
  show,
  fullscreen = false,
  className,
  innerClassName,
  closeOnEscape = false,
  closeOnOutsideClick = false,
  onClose,
  trixMode,
}: ModalDeprecatedProps) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const mayBeCloseOnEscape = () => {
    closeOnEscape && show && onClose?.();
  };

  const mayBeCloseOnOutsideClick = () => {
    closeOnOutsideClick && show && onClose?.();
  };

  useDetectEscapeKeyPress(mayBeCloseOnEscape);

  useClickAway(modalRef, mayBeCloseOnOutsideClick);

  if (!show) return null;

  const containerClassNames = classnames(`modal__box ${trixMode}`, className, {
    modal__fullscreen: fullscreen,
  });

  return (
    <>
      <div className={containerClassNames}>
        <div
          ref={modalRef}
          className={classnames("modal__inner", innerClassName)}
        >
          {children}
        </div>
      </div>
      <div className="modal-background !bg-gray-900/50" />
    </>
  );
};

Modal_DEPRECATED.Header = ModalHeader;
Modal_DEPRECATED.Body = ModalBody;
